import { DocumentTypes } from 'builder/modules/constants'
import { useMediaQueries } from 'builder/hooks/useMediaQueries'
import SelectResumeModal from 'builder/views/ResumeDistributionView/components/SelectResumeModal'

import { InfoBox, SuccessBox } from '../../'
import { WidgetTheme } from '../../WidgetTheme'
import { WidgetProps } from '../../widget.types'
import { WidgetContainer, WidgetBox } from '../../widget.styles'

import { useThemeConfig } from '../../hooks/useThemeConfig'
import { useResumeTailoringConfig } from './hooks/useResumeTailoringConfig'
import { useResumeTailoringActions } from './hooks/useResumeTailoringActions'

import * as Styles from './styles'
import ResumeTailoringImage from './assets/illustration.png'
import ResumeTailoringMobileImage from './assets/ilustration-mobile.png'

export const ResumeTailoring = ({ service }: WidgetProps) => {
  const { isPhone } = useMediaQueries()
  const theme = useThemeConfig({ service })
  const { text, status } = useResumeTailoringConfig(service)
  const { showResumeSelect, setShowResumeSelect, handleCompletedClick, onResumeTailoring } =
    useResumeTailoringActions()

  const isCompleted = status === 'completed'
  const src = isPhone ? ResumeTailoringMobileImage : ResumeTailoringImage
  const handleClick = () => {
    if (isCompleted) return handleCompletedClick()
    setShowResumeSelect(true)
  }

  return (
    <WidgetTheme theme={theme[status]} tipOrder={1}>
      <WidgetContainer>
        <WidgetBox>
          <InfoBox text={text} isCompleted={isCompleted} handleClick={handleClick} />
        </WidgetBox>
        <WidgetBox>{isCompleted ? <SuccessBox /> : <Styles.Image src={src} />}</WidgetBox>
      </WidgetContainer>
      {showResumeSelect && (
        <SelectResumeModal
          isDocumentLoaded
          title={text.modalTitle}
          onClose={() => setShowResumeSelect(false)}
          submitSelectedResume={onResumeTailoring}
          viewOnly={DocumentTypes.resume}
        />
      )}
    </WidgetTheme>
  )
}
